import React from 'react';
import { Loader } from "react-loaders";


export default function Spinner() {
    return <Loader active type="ball-spin-fade-loader"/>
}
